import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class TrainingJobFailsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      loaded: 0,
      dados: [],
      modal: false,
      data_modal: '',
    };

    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.loadData = this.loadData.bind(this);
    this.formatException = this.formatException.bind(this);
    this.formatStaff = this.formatStaff.bind(this);
    this.formatTeam = this.formatTeam.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if (mode === 'reset') {
      this.setState({ overlay: { message: '', type: '', status: 'closed' } });
    } else {
      this.setState({ overlay: { message: message, type: type, status: status } });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleMessage() {
    var message = localStorage.getItem('verify_message');
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      this.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
      localStorage.removeItem('verify_message');
    }
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }

  loadData() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/turmas/erros/integracao', {
        method: 'GET',
        mode: 'cors',
        headers: value,
      })
        .then(response => response.json())
        .catch(error => {
          console.error(error);
        })
        .then(responseJson => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson && responseJson.status === 'success') {
            self.setState({ dados: responseJson.data });
          }
        })
        .then(() => {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        });
    });
  }

  solveFail(id) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/turmas/erros/integracao/' + id, {
        method: 'PUT',
        mode: 'cors',
        headers: value,
        body: JSON.stringify({}),
      })
        .then(response => response.json())
        .catch(error => {
          console.error(error);
        })
        .then(responseJson => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson && responseJson.status === 'success') {
            var dados = self.state.dados.filter(function (item) {
              return item.id !== id;
            });
            self.setState({ dados: dados });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
    });
  }

  formatStaff(cell, row) {
    if (!row.staff_id) {
      return cell;
    }
    var url = '/aluno/editar/' + row.staff_id;
    return (
      <Link to={url}>
        <strong>{cell}</strong>
      </Link>
    );
  }

  formatTeam(cell, row) {
    if (!row.team_id) {
      return cell;
    }
    var url = '/turma/editar/' + row.team_id;
    return (
      <Link to={url}>
        {cell}
      </Link>
    );
  }

  formatException(cell, row) {
    var exception = cell || '';
    return (
      <div className="btn-group">
        <button
          className="btn btn-success btn-xs"
          onClick={() => { this.solveFail(row.id); }}
        >
          <i className="fa fa-fw fa-check"></i>
        </button>
      </div>
    );
  }

  openModal(exception) {
    this.setState({ modal: true, data_modal: exception });
  }

  render() {
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <div className="container-liquid">
          <div className="conteudo">
            <h3 className="page-title pull-left">Falhas de integração de treinamentos</h3>
            <div className="clearfix"></div>
            <hr />
            <BootstrapTable
              data={this.state.dados}
              pagination={true}
              striped={true}
              hover={true}
              exportCSV={true}
              options={{
                exportCSVText: 'Exportar CSV',
                sizePerPage: 100,
                noDataText: 'Não há falhas registradas',
                defaultSortName: 'id',
                defaultSortOrder: 'desc',
              }}
              search={true}
              multiColumnSearch={true}
              searchPlaceholder="Procurar"
            >
              <TableHeaderColumn
                dataField="id"
                isKey={true}
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="70"
              >
                ID
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="database"
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="100"
              >
                Sistema
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="training_job_id"
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="110"
              >
                Training Job
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="staff_name"
                dataFormat={this.formatStaff}
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="220"
              >
                Colaborador
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="team_name"
                dataFormat={this.formatTeam}
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="260"
              >
                Turma
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="created_at_str"
                dataAlign="center"
                dataSort={true}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="160"
              >
                Data
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="exception"
                dataAlign="center"
                dataFormat={this.formatException}
                filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }}
                width="120"
              >
                Exception
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>

        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Exception detalhada</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.setState({ modal: false }); }}>
              <i className="fa fa-fw fa-close"></i>
            </button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <pre>{this.state.data_modal}</pre>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.setState({ modal: false }); }}>
              <i className="fa fa-fw fa-close"></i>
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingJobFailsIndex;



// WEBPACK FOOTER //
// ./src/Components/Teams/TrainingJobFailsIndex.js